import styled from 'styled-components/macro';

export const Wrapper = styled.div<{ canRate: boolean }>`
  text-align: center;
  color: #f7ce10;
  font-size: 24px;
  letter-spacing: 10px;
  opacity: ${({ canRate }) => (canRate ? '1' : '0.6')};
  pointer-events: ${({ canRate }) => (canRate ? 'auto' : 'none')};

  span {
    cursor: pointer;
    transition-duration: 200ms;

    &.far {
      color: ${({ canRate }) => (canRate ? '#f7ce10' : '#D3D3D3')};
    }

    &.fas {
      color: ${({ canRate }) => (canRate ? '#f7ce10' : '#D3D3D3')};
    }
  }
`;
